import React from "react";
import { Box, Button, Paper, Typography, } from "@material-ui/core";
import { CloudUpload } from "@material-ui/icons";
import { ButtonLoader } from "frontend/src/ui/button-loader";
import { AdminLayout } from "frontend/src/pages/layouts";
import { usePageModel } from "./model";
import { Redirect } from 'react-router-dom';
var maxFileSizeInMegabytes = 512;
var Page = function (_a) {
    var uploadedFileTitle = _a.uploadedFileTitle, fileErrors = _a.fileErrors, hasUploadedFile = _a.hasUploadedFile, isSubmitting = _a.isSubmitting, onFileInputChange = _a.onFileInputChange, onFileSubmit = _a.onFileSubmit, isSuccessLoading = _a.isSuccessLoading;
    return (React.createElement(AdminLayout, null,
        React.createElement(Box, { display: "flex", justifyContent: "flex-end" }, "\u0412\u044B\u0431\u0435\u0440\u0438\u0442\u0435 ZIP-\u0430\u0440\u0445\u0438\u0432 \u0441 \u0442\u0440\u0435\u043A\u0430\u043C\u0438. \u0422\u043E\u043B\u044C\u043A\u043E ZIP, \u0434\u0440\u0443\u0433\u0438\u0435 \u0444\u043E\u0440\u043C\u0430\u0442\u044B \u043D\u0435 \u0431\u0443\u0434\u0443\u0442 \u0440\u0430\u0431\u043E\u0442\u0430\u0442\u044C"),
        React.createElement(Box, { component: Paper, p: 2 },
            React.createElement(Typography, null,
                "\u041C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u043C\u043E\u0433\u043E \u0444\u0430\u0439\u043B\u0430 - ",
                maxFileSizeInMegabytes,
                " ",
                "\u043C\u0435\u0433\u0430\u0431\u0430\u0439\u0442\u0430."),
            React.createElement(Box, { mt: 1 },
                React.createElement(Button, { variant: "contained", color: "primary", component: "label", htmlFor: "File", size: "small" }, "\u0412\u044B\u0431\u0440\u0430\u0442\u044C zip-\u0430\u0440\u0445\u0438\u0432"),
                React.createElement("input", { id: "File", hidden: true, type: "file", accept: "application/zip", onChange: onFileInputChange }))),
        hasUploadedFile && (React.createElement(Box, { component: Paper, p: 2, mt: 2 },
            React.createElement(Typography, { gutterBottom: true },
                "\u0412\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0439 \u0444\u0430\u0439\u043B - ",
                uploadedFileTitle),
            React.createElement("form", { onSubmit: onFileSubmit },
                React.createElement(Box, { mt: 1 },
                    React.createElement(ButtonLoader, { isLoading: isSubmitting, variant: "contained", color: "primary", type: "submit", startIcon: React.createElement(CloudUpload, { fontSize: "small" }) }, "\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C"))),
            isSuccessLoading && React.createElement(Redirect, { to: "../tracks" })))));
};
export var UploadTracksPage = function () {
    var pageModel = usePageModel();
    /*let title: string;
    if (pageModel.uploadedFile.file.value) {
      title = pageModel.uploadedFile.file.value.name
    }*/
    // const onFileInputChange = (e: React.FormEvent<HTMLInputElement>) => {
    //  e.persist()
    //   console.log('onFileInputChange, event is:', e)
    //  console.log(e.persist())
    //  }
    //   
    //   // if (!e.target || (!e.target as HTMLInputElement).files[0]) return;
    //   if (!e.target) return;
    //   pageModel.uploadedFile.file.set((e.target as HTMLInputElement) ?.files[0] ?? null);
    //   pageModel.uploadedFile.fileTitle.set((e.target as HTMLInputElement) ?.files[0].name ?? "");
    // };
    return (React.createElement(Page, { uploadedFileTitle: pageModel.uploadedFile.fileTitle.value, fileErrors: pageModel.uploadedFile.errors, hasUploadedFile: pageModel.uploadedFile.hasUploadedFile.value, isSubmitting: pageModel.uploadZipFile.isLoading, onFileInputChange: pageModel.uploadedFile.file.onChange, onFileSubmit: pageModel.onFileFormSubmit, isSuccessLoading: pageModel.uploadZipFile.isSuccessLoading }));
};
